/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext, useEffect } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { getData } from "../../Services/getData";
import { CompanyModel ,WorkPointModel} from "../../Utils/Models";
import { Button, Chip } from "@mui/material";
import WorkPointsForm from "./WorkPointsForm";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds, TablesIds } from "../../Utils/Constants";

export const CRUDContext = createContext(new WorkPointModel());

export default function WorkPointsTable() {
  const [contextValue, setContextValue] = useState(new WorkPointModel());
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();
  const [companies, setCompanies] = useState<CompanyModel[]>([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      const res = (await getData(
        `${endpoints.company.main}/paginated?page=0&perPage=100000`
      )) as any;
      if (!res || res?.error) return;
      setCompanies(res.data.results);
    };
    fetchCompanies();
  }, []);

  /**
   *
   */
  const workPointsColumns = [
    {
      label: `${Vocabulary.name}`,
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.phoneNumber}`,
      name: "phoneNumber",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.email}`,
      name: "email",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.company}`,
      name: "companyId",
      options: {
        sort: false,
        customBodyRender: (rowData: any) => rowData?.name || "-",
      },
    },
    {
      label: `${Vocabulary.workPoints}`,
      name: "visible",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRender: (rowData: boolean) => {
          return (
            <>
              <Chip
                color="primary"
                key={rowData.toString()}
                label={rowData ? Vocabulary.open : Vocabulary.closed}
                style={{
                  margin: 5,
                }}
              />
            </>
          );
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.workPoints}
          columns={workPointsColumns}
          CRUDEndPoint={endpoints.workPoints.main}
          id={TablesIds.workPoints}
          handleModalForm={setOpen}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setContextValue(new WorkPointModel());
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setContextValue(new WorkPointModel());
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.workPointForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={Vocabulary.editModalTitle}
            >
              <WorkPointsForm
                companies={companies}
                setContextValue={() => ({})}
                onClose={() => {
                  setOpen(false);
                  setTriggerReload(
                    triggerReload !== undefined ? !triggerReload : false
                  );
                  setContextValue(new WorkPointModel());
                }}
              />
            </GenericModal>
          }
          setContextValue={setContextValue}
          triggerReload={triggerReload}
        />
      </CRUDContext.Provider>
    </div>
  );
}
